// extracted by mini-css-extract-plugin
module.exports = {"root":"Input-root-3Da8p","input":"Input-input-2DqDH"};